export function shade(options = {}) {
	const shadeElements = document.querySelectorAll('.__jsShade');

	if (!shadeElements.length) return;

	// Tryb debug: rysuje pionowy pasek obrazujący pasmo (band) i procent
	// odsłonięcia. Włączany globalnie przez shade({ debug: true }) lub
	// per element atrybutem data-shade-debug.
	const debugAll = options.debug === true;

	const items = [];

	// Domyślne pasmo: delta od -70 do +70 px względem środka ekranu (jak dotychczas).
	// delta = środek_ekranu - środek_elementu (dodatnia = element powyżej środka ekranu).
	const DEFAULT_START = -130;
	const DEFAULT_END = 40;

	// Globalne przesunięcie pasma dla wszystkich elementów (- = efekt startuje wcześniej).
	// Można nadpisać przez shade({ offset: n }). Sumuje się z data-shade-offset.
	const DEFAULT_OFFSET = -40;
	const globalOffset = typeof options.offset === 'number' ? options.offset : DEFAULT_OFFSET;

	// Ustala granice pasma dla elementu na podstawie atrybutów:
	//   data-shade-range="start,end" -> jawne granice (np. "70,140")
	//   data-shade-range="w"         -> symetrycznie -w..w
	//   data-shade-offset="n"        -> przesuwa całe pasmo o n px (+ = wyżej/później)
	function getBand(element) {
		let start = DEFAULT_START + globalOffset;
		let end = DEFAULT_END + globalOffset;

		const rangeAttr = element.getAttribute('data-shade-range');
		if (rangeAttr) {
			const parts = rangeAttr
				.split(',')
				.map((s) => parseFloat(s.trim()))
				.filter((n) => !Number.isNaN(n));
			if (parts.length >= 2) {
				start = parts[0] + globalOffset;
				end = parts[1] + globalOffset;
			} else if (parts.length === 1) {
				start = -Math.abs(parts[0]) + globalOffset;
				end = Math.abs(parts[0]) + globalOffset;
			}
		}

		const offset = parseFloat(element.getAttribute('data-shade-offset'));
		if (!Number.isNaN(offset)) {
			start += offset;
			end += offset;
		}

		// zabezpieczenie przed dzieleniem przez zero
		if (end === start) end = start + 1;

		return { start, end };
	}

	// Podziel treść każdego elementu na wyrazy (span), a każdy wyraz na litery (i).
	// Płaska lista liter jest sterowana klasą __jsShow dokładnie jak wcześniej.
	shadeElements.forEach((element) => {
		const text = element.textContent;
		element.textContent = '';

		const letters = [];
		const words = text.split(' ');

		words.forEach((word, wordIndex) => {
			const wordSpan = document.createElement('span');
			wordSpan.className = '__jsShadeWord';

			word.split('').forEach((char) => {
				const letter = document.createElement('i');
				letter.className = '__jsShadeLetter';
				letter.textContent = char;
				wordSpan.appendChild(letter);
				letters.push(letter);
			});

			element.appendChild(wordSpan);

			// spacja pomiędzy wyrazami (zachowuje układ, nie łamie wyrazów)
			if (wordIndex < words.length - 1) {
				element.appendChild(document.createTextNode(' '));
			}
		});

		const item = { element, spans: letters, band: getBand(element) };

		// Pasek debugujący pasmo + procent odsłonięcia
		if (debugAll || element.hasAttribute('data-shade-debug')) {
			item.debugBar = createDebugBar(element, item.band);
		}

		items.push(item);
	});

	// Tworzy pionowy pasek 10px po lewej stronie elementu.
	// Wysokość = szerokość pasma (band.end - band.start), a górna krawędź
	// zaczyna się band.start px względem górnej krawędzi elementu
	// (domyślnie -70px, czyli 70px nad elementem, na 140px wysokości).
	function createDebugBar(element, band) {
		if (getComputedStyle(element).position === 'static') {
			element.style.position = 'relative';
		}

		const bar = document.createElement('span');
		bar.className = '__jsShadeDebug';
		bar.style.position = 'absolute';
		bar.style.left = '-14px';
		bar.style.top = `${band.start}px`;
		bar.style.width = '10px';
		bar.style.height = `${band.end - band.start}px`;
		bar.style.zIndex = '9999';
		bar.style.pointerEvents = 'none';
		bar.style.background = 'linear-gradient(to bottom, red 0%, red 0%, #ca8b8b 0%)';

		element.appendChild(bar);
		return bar;
	}

	// Najwyższy indeks klasy __jsLast (nadajemy __jsLast0 .. __jsLast5 -> 6 sztuk)
	const MAX_LAST = 5;

	// Surowy postęp przewinięcia elementu w jego paśmie.
	// 0 na dolnej granicy pasma (band.start), 1 na górnej (band.end).
	// Obcinamy TYLKO od dołu - górę zostawiamy otwartą, bo wartości > 1 sterują
	// stopniowym wygaszaniem klas __jsLast po wyjściu poza pasmo.
	const getScrollProgress = function (element, band) {
		const rect = element.getBoundingClientRect();
		const vh = window.innerHeight || document.documentElement.clientHeight;
		const screenCenter = vh / 2;

		// punkt odniesienia elementu - jego środek w układzie viewportu
		const elementCenter = rect.top + (rect.height / 2);

		// odległość środka elementu względem środka ekranu
		// (dodatnia = środek elementu powyżej środka ekranu)
		const delta = screenCenter - elementCenter;

		// 0% na dolnej granicy pasma (band.start), 100% na górnej (band.end)
		const progress = (delta - band.start) / (band.end - band.start);
		return Math.max(progress, 0);
	};

	const update = function (item) {
		const total = item.spans.length;
		if (!total) return;

		const rawProgress = getScrollProgress(item.element, item.band);
		// __jsShow steruje się postępem obciętym do zakresu 0..1 (jak dotychczas)
		const progress = Math.min(rawProgress, 1);
		const visibleCount = Math.round(progress * total);

		item.spans.forEach((span, index) => {
			if (index < visibleCount) {
				span.classList.add('__jsShow');
			} else {
				span.classList.remove('__jsShow');
			}
		});

		// Ile klas __jsLast pokazać liczonych od ostatniej widocznej litery.
		// W obrębie pasma: pełne okno (do 6). Po przewinięciu poza pasmo
		// (rawProgress > 1) okno kurczy się od najgłębszej klasy: najpierw
		// znika __jsLast5, na końcu __jsLast0. Krok = jedna "litera" postępu.
		const windowSize = Math.min(MAX_LAST + 1, total);
		const over = Math.max(0, (rawProgress - 1) * total);
		const tail = Math.max(0, windowSize - Math.floor(over));

		// zdejmij klasy __jsLast nadane w poprzedniej klatce
		if (item.lastMarked) {
			item.lastMarked.forEach(({ span, cls }) => span.classList.remove(cls));
		}
		item.lastMarked = [];

		// __jsLast0 = ostatnia widoczna litera, __jsLast1 = przedostatnia, ...
		for (let n = 0; n < tail; n++) {
			const idx = visibleCount - 1 - n;
			if (idx < 0) break;
			const cls = `__jsLast${n}`;
			item.spans[idx].classList.add(cls);
			item.lastMarked.push({ span: item.spans[idx], cls });
		}

		// Pasek debug: gradient odzwierciedlający procent odsłoniętych liter
		if (item.debugBar) {
			const pct = Math.round((visibleCount / total) * 100);
			item.debugBar.style.background = `linear-gradient(to bottom, red 0%, red ${pct}%, #ca8b8b ${pct}%)`;
		}
	};

	// Aktualizuj tylko elementy widoczne w viewport
	const active = new Set();
	let ticking = false;

	const onScroll = function () {
		if (ticking) return;
		ticking = true;
		window.requestAnimationFrame(() => {
			active.forEach((item) => update(item));
			ticking = false;
		});
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const item = items.find((i) => i.element === entry.target);
			if (!item) return;

			if (entry.isIntersecting) {
				active.add(item);
			} else {
				active.delete(item);
			}
			update(item);
		});
	}, {
		root: null,
		threshold: 0,
	});

	items.forEach((item) => {
		observer.observe(item.element);
		update(item);
	});

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onScroll, { passive: true });
}
